import { Injectable, inject } from '@angular/core';
import { Subject } from 'rxjs';
import { HttpParams, HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { debounceTime, switchMap, first } from 'rxjs/operators';
import { File } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  private http = inject(HttpClient);

  configUrl = environment.apiUrl;

  public getMoreFiles = new Subject<{limit: number, offset: number, onlyUnused?: boolean}>();

  getFiles() {
    const route = `${this.configUrl}r/g/listFiles`;
    return this.getMoreFiles.pipe(
      // wait 600ms after each keystroke before considering the term
      debounceTime(600),
      // switch to new search observable each time the term changes
      switchMap( ({limit, offset, onlyUnused}) => {
        const params = new HttpParams({
          fromObject: {
            limit: limit.toString(),
            offset: offset.toString(),
            onlyUnused,
          },
        });
        return this.http.get<{rows: File[], count: number}>(route, {params});
      }),
    );
  }

  deleteFiles(toDeleteFiles: File[]) {
    const route = `${this.configUrl}r/d/deleteFiles`;
    return this.http.delete<{deleted: number}>(route, ({body: {toDeleteFiles}})).pipe();
  }
}
